<template>
  <div id='avatar' :class="size" :style="`background-image: url('${imageUrl}');`">
  </div>
</template>

<script>
export default {
  props: {
    user: { type: Object },
    size: {
      type: String,
      default: 'xs',
      validator: function(value){
        return ['xxs','xxs2', 'xs', 'sm', 'md', 'lg'].indexOf(value) !== -1
      }
    }
  },
  computed: {
    imageUrl: function(){
      const url = this.user?.links?.avatar_url;
      return url ? url : this.generateAvatarUrl();
    }
  },
  methods: {
    generateAvatarUrl: function(){
      const name = (this.user ? (this.user.attributes.name || this.user.attributes.email) : this.name) || '';
      const initials = name.split(' ').slice(0, 2).map(function(str) { return str ? str[0].toUpperCase() : "";}).join('');
      const canvas = document.createElement('canvas');
      const color = ['#264653', '#2a9d8f', '#e9c46a', '#f4a261', '#e76f51'][name.length % 5];
      const size = {
        xxs: 1,
        xxs2: 1.5,
        xs: 2.5,
        sm: 3,
        md: 5,
        lg: 10
      }[this.size];
      // Size is based on styling for element which uses rem, 1 rem == 16px
      // since this is radius we need half of it then multiple by the rem factor.
      const radius = 8*size;

      canvas.width = radius*2;
      canvas.height = radius*2;

      // Get the drawing context
      var ctx = canvas.getContext('2d');
      ctx.beginPath();
      ctx.arc(radius,radius,radius, 0, 2 * Math.PI, false);
      ctx.closePath();
      ctx.fillStyle = color;
      ctx.fill();
      ctx.fillStyle = "white";
      ctx.font = `bold ${radius}px Arial`;
      ctx.textAlign = 'center';
      ctx.fillText(initials, radius,radius*4/3);
      return canvas.toDataURL();
    }
  }
}
</script>

<style lang="scss" scoped>
@import "application.scss";

#avatar {
  border: 1px solid #dedede;
  border-radius: 100%;
  align-items: center;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;

  &.xxs {
    min-width: 1rem;
    height: 1rem;
  }
    &.xxs2 {
    min-width: 1.5rem;
    height: 1.5rem;
  }

  &.xs {
    min-width: 2.5rem;
    height: 2.5rem;
  }

  &.sm {
    min-width: 3rem;
    height: 3rem;
  }

  &.md {
    min-width: 5rem;
    height: 5rem;
  }

  &.lg {
    min-width: 10rem;
    height: 10rem;
  }
}
</style>